import { Clock } from './Clock';
export class BrowserClock extends Clock {
    startTime;
    startTimestamp;
    pausedTimestamp;
    constructor(startTime = 0, paused = true) {
        super();
        this.startTime = startTime;
        this.startTimestamp = performance.now() - startTime * 1000;
        this.pausedTimestamp = paused ? this.startTimestamp : undefined;
    }
    async _seek(time) {
        this.startTime = time;
        this.startTimestamp = performance.now();
        if (this.pausedTimestamp != null) {
            this.pausedTimestamp = this.startTimestamp;
        }
        return this.now;
    }
    async _pause() {
        if (!this.paused) {
            this.pausedTimestamp = performance.now();
            return this.now;
        }
        else {
            throw new Error('Browserclock is already paused');
        }
    }
    async _end() {
        return this.now;
    }
    async _resume() {
        if (this.pausedTimestamp != null) {
            this.startTimestamp = performance.now() - (this.pausedTimestamp - this.startTimestamp);
            this.pausedTimestamp = undefined;
            return this.now;
        }
        else {
            throw new Error('Browserclock is already running');
        }
    }
    close() {
    }
    get paused() {
        return this.pausedTimestamp != undefined;
    }
    get isRunning() {
        return !this.paused;
    }
    get now() {
        return this.startTime +
            ((this.pausedTimestamp ?? performance.now()) - this.startTimestamp) / 1000;
    }
    timeAt(perfTime) {
        const now = this.now;
        if (this.isRunning) {
            const perfNow = performance.now();
            return now + (perfTime - perfNow) / 1000;
        }
        else {
            return now;
        }
    }
}
//# sourceMappingURL=BrowserClock.js.map